const config = {
  apiUrl:
    window.location.hostname === "localhost"
      ? "http://localhost:4000/v1"
      : `${window.location.origin}/api/v1`,
  baseUrl:
    window.location.hostname === "localhost"
      ? "http://localhost:4000/"
      : `${window.location.origin}/`,
  nxmapBaseUrl: "https://nxmaptest.evercomm.com.sg",
  nxplanBaseUr: "https://dev.nxplan.evercomm.io/",
};

export default config;
